import './App.css';
import './assets/theme.css';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as microsoftTeams from "@microsoft/teams-js";

import Main from "./components/Main";  
import Bot from "./components/Bot/Bot";  
import styles from "./App.module.css";  
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

function App() {
    const { instance, inProgress, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [userInfo, setUserInfo] = useState(null);
    const [teamsContext, setTeamsContext] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const loginRequest = {
        scopes: ["User.Read"],
    };

    const handleLogin = () => {
        instance.loginPopup(loginRequest).catch(e => {
            console.error(e);
        });
    };

    const handleLogout = () => {
        instance.logoutPopup().catch(e => {
            console.error(e);
        });
    };

    useEffect(() => {
        if (isAuthenticated && accounts.length > 0) {
            setUserInfo(accounts[0]);
        } else {
            setUserInfo(null);
        }
    }, [isAuthenticated, accounts]);

    // Nuevo efecto para cuando la app se abre en un navegador con parámetros en la URL
    useEffect(() => {
        // Este efecto maneja el caso donde la app se abre en un navegador
        // y el contexto de Teams se pasa como un parámetro en la URL.
        const currentUrl = new URL(window.location.href);
        const contextParam = currentUrl.searchParams.get('context');

        console.log("URL actual completa:", window.location.href);

        if (contextParam) {
            console.log("Parámetro 'context' encontrado en la URL:", contextParam);
            try {
                // El parámetro 'context' es un string JSON, así que lo parseamos.
                const context = JSON.parse(contextParam);
                if (context && context.subEntityId) {
                    const [surveyId, userId, messageId] = context.subEntityId.split('/');
                    console.log("Extraído de la URL -> surveyId:", surveyId, "userId:", userId, "messageId: ", messageId);

                    if (surveyId && userId && messageId) {
                        // Navegamos a la ruta de la encuesta en vivo si tenemos los IDs
                        navigate(`/live-survey/${surveyId}/${userId}/${messageId}`);
                    }
                }
            } catch (error) {
                console.error("Error al interpretar el parámetro 'context' de la URL:", error);
            }
        }
    }, []);

    useEffect(() => {
        setLoading(true);
        microsoftTeams.app.initialize().then(() => {
            console.log("Teams SDK initialized");
            microsoftTeams.app.getContext().then(context => {
                console.log("Teams SDK context: ", context);
                setTeamsContext(context);
                setLoading(false);
                if (context.page.subPageId) {
                    const [surveyId, userId, messageId] = context.page.subPageId.split("/");
                    console.log("PARAMS: ", surveyId, userId, messageId)
                    if (surveyId && userId && messageId) {
                        navigate(`/${surveyId}/${userId}/${messageId}`)
                    } else {
                        if (surveyId && userId) {
                            navigate(`/${surveyId}/${userId}`)
                        }
                    }
                }
            }).catch( error => {
                console.error("Error getting context Teams SDK: ", error)
                setLoading(false);
            })
        }).catch( error => {
            console.error("Error initializing Teams SDK: ", error)
            setLoading(false);
        })

    }, [navigate]);
  ///////////////////////////
  const [isBotVisible, setIsBotVisible] = useState(false);  
  
  const handleOpenBot = () => {  
    setIsBotVisible(true);
  };  
  
  const handleCloseBot = () => {  
    setIsBotVisible(false);
  }; 

    if (inProgress === InteractionStatus.Startup || inProgress === InteractionStatus.HandleRedirect) {
        return <div>Authenticating...</div>;
    }

   return (  
     <div className={styles.app}>
       {/* Main Component */}
       <div
         className={styles.home}
         style={{
           width: isBotVisible ? "70%" : "100%", // Shrink Main to 70% when Bot is visible  
           transition: "width 0.5s ease-in-out", // Smooth transition effect  
         }}
       >
         <Main userInfo={userInfo} handleLogout={handleLogout} handleLogin={handleLogin} isBotVisible={isBotVisible}> 
            {/* Render "Open Bot" button only if Bot is not visible */}
            {!isBotVisible && userInfo && (
                <button className={styles.openBotButton} onClick={handleOpenBot}>
                <span className={" material-symbols-rounded " + styles.agentIcon }>support_agent</span>
                </button>
            )}
         </Main>
       </div>

       

       {/* Render Bot component only when isBotVisible is true */}
       {isBotVisible && (
         <div className={`${styles.bot} ${  
          window.innerWidth <= 768 ? styles.botIsVisible : ""  
        }`}  >
           <Bot userInfo={userInfo} onClose={handleCloseBot}  />
         </div>
       )}
     </div>  
  );  
}

export default App;
